import { initialModel } from '@src/utils'
import * as models from './models'

const reducers = {
  resetIntegrationReportState: state => ({ ...state, [models.ANALYTICS_INTEGRATION_LIST]: initialModel }),
}

export default reducers
